var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("notifications", {
    class: ["server-notifs", _vm.$i18n.locale === "en" && "lang-en"].filter(
      Boolean
    ),
    attrs: {
      position: "bottom " + (_vm.$i18n.locale === "fa" ? "right" : "left")
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }